import { render, staticRenderFns } from "./new-plus-white-svg.vue?vue&type=template&id=70d3169f&scoped=true"
import script from "./new-plus-white-svg.vue?vue&type=script&lang=js"
export * from "./new-plus-white-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3169f",
  null
  
)

export default component.exports